<template>
  <div class="filters-section">
    <div class="filter-group">
      <div class="filter-title">
        <b-icon icon="currency-euro"></b-icon>
        {{ $t('sidebar.price') }}
      </div>
      <div class="filter-options price-options">
        <label
          class="filter-option"
          :class="{ 'is-checked': priceFilter === null }"
        >
          <input
            type="radio"
            name="priceFilter"
            :checked="priceFilter === null"
            @change="setPriceFilter(null)"
          />
          <span>{{ $t('sidebar.all') }}</span>
        </label>
        <label
          class="filter-option"
          :class="{ 'is-checked': priceFilter === 'free' }"
        >
          <input
            type="radio"
            name="priceFilter"
            :checked="priceFilter === 'free'"
            @change="setPriceFilter('free')"
          />
          <span>{{ $t('sidebar.free') }}</span>
        </label>
        <label
          class="filter-option"
          :class="{ 'is-checked': priceFilter === 'paid' }"
        >
          <input
            type="radio"
            name="priceFilter"
            :checked="priceFilter === 'paid'"
            @change="setPriceFilter('paid')"
          />
          <span>{{ $t('sidebar.paid') }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PriceFilter',

  computed: {
    priceFilter() {
      return this.$store.state.priceFilter
    }
  },

  methods: {
    setPriceFilter(filter) {
      this.$store.dispatch('setPriceFilter', filter)
      this.$emit('filter-changed')
    }
  }
}
</script>

<style lang="scss" scoped>
.price-options {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  flex-wrap: wrap;

  .filter-option {
    flex: 0 0 auto;
  }
}
</style>
